import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Generate an easy-to-read, easy-to-type password: a darts word + 2 digits.
export function generatePassword() {
  const words = ["darts", "oche", "treble", "bullseye", "checkout", "arrows", "tungsten", "maximum", "ton", "leg"];
  const word = words[Math.floor(Math.random() * words.length)];
  const num = Math.floor(10 + Math.random() * 90); // 10-99
  return `${word}${num}`;
}
